import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, Coffee, ZapOff, BrainCircuit } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-[#faf8f5] text-[#1a1f3a]" data-id="element-133">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-134">
        <FadeIn data-id="element-135">
          <div className="text-center mb-16" data-id="element-136">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-137">
              Te voy a decir algo incómodo{' '}
              <span className="text-[#d4a574]" data-id="element-138">(y liberador)</span>
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-139">
              Si estás cansada todos los días,{' '}
              <strong data-id="element-140">no es que te falte fuerza de voluntad</strong>.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20" data-id="element-141">
          <FadeIn delay={200} data-id="element-142">
            <div className="space-y-6 text-lg text-gray-700" data-id="element-143">
              <p data-id="element-144">
                La fuerza de voluntad no regula tu sueño. No estabiliza tu
                glucosa. No baja tu cortisol. No apaga el modo “alerta” que se
                te queda pegado en el cuerpo.
              </p>
              <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-[#d4a574]" data-id="element-145">
                <p className="font-medium text-[#1a1f3a]" data-id="element-146">
                  Lo que te falta no es empuje. Es un sistema.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={400} data-id="element-147">
            <div className="bg-white p-8 rounded-2xl shadow-lg relative overflow-hidden" data-id="element-148">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#faf8f5] rounded-bl-full -mr-10 -mt-10" data-id="element-149"></div>
              <h3 className="text-xl font-bold mb-6 relative z-10" data-id="element-150">
                El problema real: tu energía se desordena
              </h3>
              <ul className="space-y-4 relative z-10" data-id="element-151">
                {['Cenar tarde', 'Estrés acumulado', 'Pantallas en la noche', 'Desayunos rápidos (o inexistentes)', 'Entrenar fuerte cuando ya estás drenada'].map((item, i) => <li key={i} className="flex items-center text-gray-600" data-id="element-152">
                    <span className="w-2 h-2 bg-[#d4a574] rounded-full mr-3" data-id="element-153"></span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={600} data-id="element-154">
          <div className="bg-[#1a1f3a] text-[#faf8f5] rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-155">
            <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-156"></div>
            <h3 className="text-2xl font-serif mb-8 relative z-10" data-id="element-157">
              El ciclo que te atrapa
            </h3>

            <div className="flex flex-wrap justify-center items-center gap-4 text-lg font-medium relative z-10" data-id="element-158">
              <span className="flex items-center" data-id="element-159">
                <Coffee className="w-5 h-5 mr-2 text-[#d4a574]" data-id="element-160" /> Café
              </span>
              <span className="text-gray-500" data-id="element-161">→</span>
              <span className="flex items-center" data-id="element-162">
                <ZapOff className="w-5 h-5 mr-2 text-[#d4a574]" data-id="element-163" /> Pico
              </span>
              <span className="text-gray-500" data-id="element-164">→</span>
              <span className="flex items-center" data-id="element-165">Bajón</span>
              <span className="text-gray-500" data-id="element-166">→</span>
              <span className="flex items-center" data-id="element-167">Antojo</span>
              <span className="text-gray-500" data-id="element-168">→</span>
              <span className="flex items-center" data-id="element-169">
                <AlertCircle className="w-5 h-5 mr-2 text-[#d4a574]" data-id="element-170" /> Culpa
              </span>
              <span className="text-gray-500" data-id="element-171">→</span>
              <span className="flex items-center text-[#d4a574]" data-id="element-172">
                Más cansancio
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={800} data-id="element-173">
          <div className="mt-20 text-center" data-id="element-174">
            <h3 className="text-2xl font-bold mb-6" data-id="element-175">
              Por qué lo que intentaste no se sostiene
            </h3>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-176">
              {[{
              title: 'Dietas agresivas',
              desc: 'Peor sueño, más ansiedad, más bajones.'
            }, {
              title: 'Ejercicio intenso',
              desc: 'Sin base, te drena y abandonas.'
            }, {
              title: 'Suplementos sueltos',
              desc: 'Gasto + frustración sin un sistema.'
            }].map((card, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-177">
                  <h4 className="font-bold text-[#1a1f3a] mb-2" data-id="element-178">
                    {card.title}
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-179">{card.desc}</p>
                </div>)}
            </div>
            <p className="mt-8 text-lg font-medium text-[#1a1f3a]" data-id="element-180">
              No fallaste tú. Falló el enfoque.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}